import { createContext, Dispatch, use, useMemo, useReducer } from 'react'
import { ReducerState, PageReducerAction, reducer } from './reducer'

export type PageContextType = {
  state: ReducerState
  dispatch: Dispatch<PageReducerAction>
}

export type PageContextStateType = ReducerState

export const PageContext = createContext<PageContextType | null>(null)

export const PageContextProvider = ({ children, defaultState }: { children: React.ReactNode; defaultState: PageContextStateType }) => {
  const [state, dispatch] = useReducer(reducer, defaultState)
  const value = useMemo(() => ({ state, dispatch }), [state, dispatch])

  return <PageContext value={value}>{children}</PageContext>
}

export const usePageContext = () => {
  const context = use(PageContext)

  if (!context) throw new Error(`usePageContext must be used within a PageContextProvider`)

  return context
}
